import { hooks } from '@approvalmax/utils';
import { useSelector } from 'modules/react-redux';
import { mapQBooksContacts } from 'pages/requestForm/data/qbooks/QBooksContact';
import { getRequestEditMode } from 'pages/requestForm/selectors/requestSelectors';
import { getRuleTypeByEditMode } from 'pages/requestForm/utils/helpers';
import { useCallback, useMemo, useState } from 'react';
import { useGetQBooksCustomersRaw } from 'shared/data/webApp/v1';

import { useRequest } from '../../hooks';

export const useCustomers = () => {
    const request = useRequest();
    const editMode = useSelector((state) => getRequestEditMode(state, request));

    const ruleType = getRuleTypeByEditMode(editMode);

    const [enabled, setEnabled] = useState(false);
    const [query, setQuery] = useState('');
    const queryDebounced = hooks.useDebounce(query, 500);

    const { data, isFetching } = useGetQBooksCustomersRaw(
        {
            query: {
                requestId: request.id,
                companyId: request.companyId,
                query: queryDebounced,
                startFrom: 0,
                rowNum: 1000,
                ruleType,
            },
        },
        {
            enabled,
            keepPreviousData: true,
            staleTime: 1000 * 60,
        }
    );

    const trigger = useCallback(() => {
        setEnabled(true);
    }, []);

    const items = useMemo(() => mapQBooksContacts(data?.Contacts ?? []), [data?.Contacts]);

    return {
        items,
        isFetching,
        trigger,
        setQuery,
    };
};
